import React, {useEffect, useState} from "react";
import {Container, Form, Row} from "react-bootstrap";
import Switch from "react-switch";

import DeclarationPopupTFAF from "./DeclarationPopupTFAF";
import {useSearchParams} from "react-router-dom";
import {
  CheckCircleIconLight,
  CheckCircleIconLight_AA,
  CheckCircleIconVTNZ,
  CrossCircleIconLight,
  GreenTickIcon
} from "./common/TfafCommonComponent";
import TooltipTFAF from "./common/TooltipTFAF";
import {useLocation} from "react-use";
import SaveEmailQuote from "./SaveEmailQuote";
import NavigateMBI from "./NavigateMBI";
import NavigateAAMBI from "./NavigateAAMBI";
import {useFeature} from '../hooks/useFeature';
import gaspyLearnMore from '../images/gaspy-learn-more.jpg';


const PolicyDetailsTFAF = props => {
  const [showDeclStatement, setShowDeclStatement] = useState(false);
  const [declarationPopupShow, setDeclarationPopupShow] = useState(false);
  const [searchParams] = useSearchParams();
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [isTurners, setIsTurners] = useState(false);
  const [selectedCover, setSelectedCover] = useState(''); // State to keep track of the selected radio button
  const [selectedTerm, setSelectedTerm] = useState();
  const [excess, setExcess] = useState(new Map());
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const location = useLocation();
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [defaultCoverExcess, setDefaultCoverExcess] = useState(new Map())
  const [hasErrors, setHasErrors] = useState(false);
  const [pageErrors, setPageErrors] = useState('');
  const isAAPath = props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER';
  const isVTNZPath = props.inputValues.source === 'VTNZ';
  const gaspyPromoEnabled = useFeature('gaspy-free-fuel-promo');
  const backgroundColorsMobile = isAAPath ? ['white', '#6363631A'] : ['white', '#F3F4F6'];
  let currentBackgroundColorMobileIndex = 0;
  const aaRoadService = props.inputValues.aaRoadService;
  const consumables = props.inputValues.consumables;
  const travelDisruption = props.inputValues.travelDisruption;
  const [benefitsCollapsed, setBenefitsCollapsed] = useState(false);
  const baseUrl = window.location.origin;

  const updateMap = (k, v) => {
    setExcess(excess.set(k, v));
  }

  const updateDefaultCoverExcessMap = (k, v) => {
    setDefaultCoverExcess(defaultCoverExcess.set(k, v));
  }

  const checkForErrors = (category = 'Submit') => {
    setHasErrors(false);
    setPageErrors('');
    if (props.inputValues.selectedTermAndCover === null
      || !props.inputValues.selectedTermAndCover.hasOwnProperty('coverName')
      || !props.inputValues.selectedTermAndCover.hasOwnProperty('coverCode')
      || !props.inputValues.selectedTermAndCover.hasOwnProperty('term')
      || !props.inputValues.selectedTermAndCover.coverName
      || props.inputValues.selectedTermAndCover.term === "0") {
      setPageErrors('Select cover, excess and term')
      setHasErrors(true);

      if (!window.location.hostname.includes('aa')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: category,
          status: 'Fail',
          virtualUrl: `${baseUrl}/mbi/step2`,
          pageTitle: 'Choose Your Cover',
        });
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      return true;
    }

    if (props.inputValues.excess === 0) {
      setPageErrors('Please select a valid excess option')
      setHasErrors(true);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      return true;
    }
    return false;
  }
  const clickNext = () => {
    if (!checkForErrors()) {

      if (!window.location.hostname.includes('aa')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Submit',
          status: 'Success',
          virtualUrl: `${baseUrl}/mbi/step2`,
          pageTitle: 'Choose Your Cover',
        });
      }

      handleClick(true);
    }
  }

  const formatClaimLimit = (cl) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(cl);
  }

  const defaultExcessSelection = (coverName) => {
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    if (cover) {
      for (let excessVar of cover.excesses) {
        if (excessVar.status == 'CONDITIONALLY_ACTIVE' || excessVar.status == 'ACTIVE') {
          updateDefaultCoverExcessMap(coverName, excessVar.excess);
        }
      }
    }
  }
  const saveAndEmailQuote = () => {
    if (!checkForErrors('Email My Quote Start')) {
      handleClick(false);
      setShowEmailPopup(true);

      if (!window.location.hostname.includes('aa')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Email My Quote Start',
          virtualUrl: `${baseUrl}/mbi/step2`,
          pageTitle: 'Choose Your Cover',
        });
      }

    }
  }
  useEffect(() => {
    if (props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverCode !== null) {
      console.log("props.inputValues", props.inputValues)
      handleExcessChange(props.inputValues.selectedTermAndCover.coverName, props.inputValues.excess);
      if (props.inputValues.selectedTermAndCover) {
        setSelectedCover(props.inputValues.selectedTermAndCover.coverName);
        setSelectedTerm(props.inputValues.selectedTermAndCover.term);
        updateMap(props.inputValues.selectedTermAndCover.coverName, props.inputValues.excess);

      }
      if (props.inputValues.selectedTermAndCover.coverName === props.cover1) {
        defaultExcessSelection(props.cover2);
      } else {
        defaultExcessSelection(props.cover1);
      }
    } else {
      defaultExcessSelection(props.cover1);
      defaultExcessSelection(props.cover2);
      setIsFirstTime(true);
    }

    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);

    // Auto-collapse benefits section on mobile when user scrolls down
    /*   const handleScroll = () => {
         if (window.innerWidth <= 767) {
           const scrollPosition = window.scrollY;
           const benefitsSection = document.getElementById('benefits-section');
           if (benefitsSection) {
             if (scrollPosition > 600) {
               setBenefitsCollapsed(true);
             } else {
               setBenefitsCollapsed(false);
             }
           }
         }
       };

       window.addEventListener('scroll', handleScroll);*/

    if (props.inputValues.source === 'TFAF') {
      setIsTurners(true);
    }
    // Track the 'page loaded' event
    if (window.gtag) {
      window.gtag('event', 'Page visited', {
        event_category: 'Page',
        event_label: 'Policy detail page',
      });
    }
    if (isAAPath) {
      // Push virtual pageview event to dataLayer for GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualUrl': '/quotes',
        'pageTitle': 'Quotes'
      });
    }
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Page View',
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover',
      });
    }

    /*  return () => {
        window.removeEventListener('scroll', handleScroll);
      };*/
  }, []);

  const policyLink = () => {
    if (props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER') {
      return "https://docs.autosure.co.nz/policy_books/aa/mbi.pdf";
    } else {
      return "https://docs.autosure.co.nz/policy_books/turners/mbi.pdf";
    }
  }
  const getNextBackgroundColorMobile = () => {
    const nextColor = backgroundColorsMobile[currentBackgroundColorMobileIndex];
    currentBackgroundColorMobileIndex = (currentBackgroundColorMobileIndex + 1) % backgroundColorsMobile.length;
    return nextColor;
  };
  const steps = [// {name: 'Step 1', status: 'complete'},
    {name: 'Step 1', status: 'complete', desc: 'Car details'}, {
      name: 'Step 2', status: 'current', desc: 'Choose your cover'
    }, {name: 'Step 3', status: 'upcoming', desc: 'About you'}, {
      name: 'Step 4', status: 'upcoming', desc: 'Pay now'
    },];
  const handleExcessChange = (cover, upExcess) => {
    console.log("handleExcessChange cover", cover)
    setSelectedCover(cover);
    setIsFirstTime(false);
    props.handleChangeValue('excess', upExcess);
    updateMap(cover, upExcess);
    let coverName = cover;
    let coverCode = getCoverCode(coverName);
    let term = props.inputValues.selectedTermAndCover.term;
    if (term === undefined && selectedTerm !== undefined && selectedTerm !== '') {
      term = selectedTerm;
    }
    handleRadioChange(cover, term, true);
    props.handleChangeValue('excess', excess.get(coverName));

    let catDetails = "$" + upExcess
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Excess Option',
        categoryDetails: catDetails,
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover',
      });
    }
  }
  const handleNewQuoteClick = () => {
    window.location.href = '/mbi?step=1';
  };

  const handleClick = (showDeclaration) => {
    let id;
    if (props.inputValues.source === 'TFAF') {
      id = searchParams.get("id");
    } else {
      id = props.inputValues.id;
    }
    const aaMemberData = {
      aaMemberNumber: props.inputValues.aaMembershipNumber,
      lastName: props.inputValues.aaMemberLastName,
      dateOfBirth: props.inputValues.aaMemberDOB
    }

    // Build optionalComponents string based on user selections
    const selectedOptionalComponents = [];
    if (consumables) {
      selectedOptionalComponents.push('ConsumableItems');
    }
    if (aaRoadService) {
      selectedOptionalComponents.push('Roadside');
    }
    if (travelDisruption) {
      selectedOptionalComponents.push('TravelDisruption');
    }
    const optionalComponents = selectedOptionalComponents.join(';');

    const prospectData = {
      id: id,
      term: props.inputValues.selectedTermAndCover.term,
      premium: props.inputValues.selectedTermAndCover.premium,
      excess: props.inputValues.excess,
      claimLimit: getClaimLimitForCover(props.inputValues.selectedTermAndCover.coverName),
      code: props.inputValues.selectedTermAndCover.coverCode,
      name: props.inputValues.selectedTermAndCover.coverName,
      aaMemberData: aaMemberData,
      optionalComponents: optionalComponents
    };

    fetch(`${url}/campaign/policy-renewal/prospects`, {
      method: 'PUT',
      mode: "cors",
      headers: {
        'Content-Type': 'application/json',
        "Authorization": 'By-Pass-Auth-Create-Prospect'
      },
      body: JSON.stringify(prospectData)
    })
      .then((response) => response.json())
      .then((data) => {
        props.updateAmendQuoteResponse(JSON.stringify(data.amendQuoteResponse));
      })
      .catch((error) => {
        console.error('API call error:', error);
      });
    setDeclarationPopupShow(showDeclaration);
  }
  const getPremium1 = (coverName, term) => {
    let NZDollar = Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'USD',
    });
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    if (cover) {

      let selectedExcess = null;
      for (let excessVar of cover.excesses) {
        if (selectedExcess == null && (excessVar.status === 'ACTIVE' || excessVar.status === 'CONDITIONALLY_ACTIVE')) {
          selectedExcess = excessVar;
        }
        if (isFirstTime) {
          if (excessVar.excess === defaultCoverExcess.get(coverName)) {
            selectedExcess = excessVar;
          }
        } else {
          if (excess.get(coverName) !== undefined) {
            if (excessVar.excess === excess.get(coverName)) {
              selectedExcess = excessVar;
            }
          } else {
            if (excessVar.excess === defaultCoverExcess.get(coverName)) {
              selectedExcess = excessVar;
            }
          }
        }
      }
      if (excess.get(coverName) != null && excess.get(coverName) === undefined && (selectedExcess.status === 'ACTIVE' || selectedExcess.status === 'CONDITIONALLY_ACTIVE')) {
        updateMap(coverName, selectedExcess.excess);
        props.handleChangeValue('excess', selectedExcess.excess);
      }
      const premium = selectedExcess.premiums.find(
        (p) => p.term.toString() === term
      );
      // Ensure premium object is not undefined and has valid retailAmount and discountedAmount
      if (premium) {
        let retailAmount = premium.retailAmount || 0; // Default to 0 if undefined
        let nonDiscountedAmount = premium.discountedAmount !== undefined ? premium.discountedAmount : null; // Default to null if undefined

        // Add ROADSIDE optionalComponents premium if AA Road Service is enabled
        if (aaRoadService && premium.optionalComponents) {
          const roadsideComponent = premium.optionalComponents.find(component => component.type === 'Roadside');
          if (roadsideComponent) {
            retailAmount += roadsideComponent.retailPremium;
            if (nonDiscountedAmount !== null) {
              nonDiscountedAmount += roadsideComponent.retailPremium;
            }
          }
        }
        if (consumables && premium.optionalComponents) {
          const consumablesComponent = premium.optionalComponents.find(component => component.type === 'ConsumableItems');
          if (consumablesComponent) {
            retailAmount += consumablesComponent.retailPremium;
            if (nonDiscountedAmount !== null) {
              nonDiscountedAmount += consumablesComponent.retailPremium;
            }
          }
        }
        if (travelDisruption && premium.optionalComponents) {
          const travelDisruptionComponent = premium.optionalComponents.find(component => component.type === 'TravelDisruption');
          if (travelDisruptionComponent) {
            retailAmount += travelDisruptionComponent.retailPremium;
            if (nonDiscountedAmount !== null) {
              nonDiscountedAmount += travelDisruptionComponent.retailPremium;
            }
          }
        }

        if (premium.discountedAmount !== null && props.inputValues.validAaMember !== 'YES') {
          props.handleChangeValue('validAaMember', 'YES');
        }
        // Return formatted values, ensure no NaN values are passed
        return {
          retailAmount,
          discountedAmount: nonDiscountedAmount,
          formattedRetailAmount: retailAmount ? NZDollar.format(retailAmount) : null,
          formattedNonDiscountedAmount: nonDiscountedAmount !== null ? NZDollar.format(nonDiscountedAmount) : null,
        };
      }
    }

    return null;
  };
  const getPremium = (coverName, term) => {
    let NZDollar = Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'USD',
    });
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    if (cover) {

      let selectedExcess = null;
      for (let excessVar of cover.excesses) {
        if (selectedExcess == null && (excessVar.status === 'ACTIVE' || excessVar.status === 'CONDITIONALLY_ACTIVE')) {
          selectedExcess = excessVar;
        }
        if (isFirstTime) {
          if (excessVar.excess === defaultCoverExcess.get(coverName)) {
            selectedExcess = excessVar;
          }
        } else if (excess.get(coverName) !== undefined) {
          if (excessVar.excess === excess.get(coverName)) {
            selectedExcess = excessVar;
          }
        }
      }
      if (excess.get(coverName) != null && excess.get(coverName) === undefined && (selectedExcess.status === 'ACTIVE' || selectedExcess.status === 'CONDITIONALLY_ACTIVE')) {
        updateMap(coverName, selectedExcess.excess);
        props.handleChangeValue('excess', selectedExcess.excess);
      }
      const premium = selectedExcess.premiums.find(
        (p) => p.term.toString() === term
      );

      if (premium) {
        let retailAmount = premium.retailAmount || 0;

        // Add optional components premium if selected
        if (aaRoadService && premium.optionalComponents) {
          const roadsideComponent = premium.optionalComponents.find(component => component.type === 'Roadside');
          if (roadsideComponent) {
            retailAmount += roadsideComponent.retailPremium;
          }
        }
        if (consumables && premium.optionalComponents) {
          const consumablesComponent = premium.optionalComponents.find(component => component.type === 'ConsumableItems');
          if (consumablesComponent) {
            retailAmount += consumablesComponent.retailPremium;
          }
        }
        if (travelDisruption && premium.optionalComponents) {
          const travelDisruptionComponent = premium.optionalComponents.find(component => component.type === 'TravelDisruption');
          if (travelDisruptionComponent) {
            retailAmount += travelDisruptionComponent.retailPremium;
          }
        }

        return NZDollar.format(retailAmount);
      }
    }
    return null;

  };

  const getClaimLimitForCover = (coverName) => {
    const cover = props.parentAmendQuoteResponse.covers.find((cover) => cover.coverName === coverName);
    if (cover && cover.excesses && cover.excesses.length > 0) {
      return cover.excesses[0].claimLimit;
    }
    return null;
  };
  const getExcess = (coverName, excessUpdated) => {
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    let excesses = [];
    if (cover) {
      for (let excessVar of cover.excesses) {
        if (excessVar.status == 'CONDITIONALLY_ACTIVE' || excessVar.status == 'ACTIVE') {
          excesses.push(excessVar.excess);
        }
      }
    }
    return excesses;

  };
  const getStatus = (coverName) => {

    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );

    if (cover) {
      let status = cover.excesses[0].status;
      for (let i = 0; i < cover.excesses.length; i++) {
        if (cover.excesses[i].status == 'CONDITIONALLY_ACTIVE' || cover.excesses[i].status == 'ACTIVE') {
          status = cover.excesses[i].status;
        }
      }
      return status;
    }

    return "NA";
  };
  const isActive = (coverName) => {
    return getStatus(coverName) === 'ACTIVE' || getStatus(coverName) === 'CONDITIONALLY_ACTIVE';
  }
  const getClaimLimit = (coverName, selectedExcess) => {
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );

    if (cover) {
      let excessFound = null;
      if (selectedExcess === undefined) {
        excessFound = cover.excesses[0];
      } else {
        excessFound = cover.excesses.find(
          (ex) => ex.excess === selectedExcess
        );
      }
      if (excessFound) {
        if (isNaN(excessFound.claimLimit)) {
          return excessFound.claimLimit;
        } else {
          return formatClaimLimit(excessFound.claimLimit);
        }
      }
    }

    return "NA";
  };
  const getBenefitDescription = (cover, type) => {
    return JSON.parse(props.inputValues.additionalBenefit.get(cover)).find((ab) => ab.name === type).description;
  }
  const handleRadioChange = (coverName, term, skipTracking = false) => {

    if (!skipTracking) {
      let catDetails = coverName + " - " + (term / 12) + " year"
      if (!window.location.hostname.includes('aa')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Select your Term & Premium',
          categoryDetails: catDetails,
          virtualUrl: `${baseUrl}/mbi/step2`,
          pageTitle: 'Choose Your Cover',
        });
      }
    }

    if (isFirstTime) {
      updateMap(coverName, defaultCoverExcess.get(coverName));
    }
    props.parentQuote.cover = coverName;
    props.parentQuote.term = term;
    props.parentQuote.premium = getPremium1(coverName, term).formattedRetailAmount;
    props.parentQuote.claimLimit = getClaimLimitForCover(coverName);
    let premium = getPremium1(coverName, term).formattedRetailAmount;
    setSelectedCover(coverName);
    setSelectedTerm(term);
    let coverCode = getCoverCode(coverName);
    props.inputValues.selectedTermAndCover = {coverName, coverCode, term, premium};
    props.handleChangeValue("selectedTermAndCover", props.inputValues.selectedTermAndCover);
    let selectedExcess = excess.get(coverName)

    if (selectedExcess === undefined) {
      selectedExcess = defaultCoverExcess.get(coverName);
    }
    props.handleChangeValue('excess', selectedExcess);
    setIsFirstTime(false);
  };

  const getCoverCode = (coverName) => {
    console.log("props coverName", props, coverName)
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    console.log("cover", cover)
    return cover.coverCode;
  }
  const isHighlighted = (coverName) => {
    return coverName === selectedCover;
  };
  const handleAARoadService = (nextChecked) => {
    props.handleChangeValue('aaRoadService', nextChecked);
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Select your additional benefits',
        categoryDetails: 'AA Roadservice',
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover',
      });
    }
    // Check which cover and term user has selected and update premium
    if (props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName && props.inputValues.selectedTermAndCover.term) {
      const coverName = props.inputValues.selectedTermAndCover.coverName;
      const term = props.inputValues.selectedTermAndCover.term;

      // Trigger re-calculation of premium by calling handleRadioChange
      setTimeout(() => {
        handleRadioChange(coverName, term, true);
      }, 0);
    }
  };
  const handleConsumables = (nextChecked) => {
    props.handleChangeValue('consumables', nextChecked);
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Select your additional benefits',
        categoryDetails: 'Consumables',
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover',
      });
    }
    // Check which cover and term user has selected and update premium
    if (props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName && props.inputValues.selectedTermAndCover.term) {
      const coverName = props.inputValues.selectedTermAndCover.coverName;
      const term = props.inputValues.selectedTermAndCover.term;

      // Trigger re-calculation of premium by calling handleRadioChange
      setTimeout(() => {
        handleRadioChange(coverName, term, true);
      }, 0);
    }
  };
  const handleTravelDisruption = (nextChecked) => {
    props.handleChangeValue('travelDisruption', nextChecked);
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Select your additional benefits',
        categoryDetails: 'Travel Disruption',
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover',
      });
    }
    // Check which cover and term user has selected and update premium
    if (props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName && props.inputValues.selectedTermAndCover.term) {
      const coverName = props.inputValues.selectedTermAndCover.coverName;
      const term = props.inputValues.selectedTermAndCover.term;

      // Trigger re-calculation of premium by calling handleRadioChange
      setTimeout(() => {
        handleRadioChange(coverName, term, true);
      }, 0);
    }
  };


  return (
    <Container className='container-padding'
               style={{
                 marginBottom: '100px',
               }}>
      <br/>
      <Row className="justify-content-center">
        {isAAPath ? (
          <> <br/> <NavigateAAMBI steps={steps}/> </>
        ) : (
          <NavigateMBI steps={steps}/>
        )}
      </Row>

      <div className="regularErrorStyleCenter">{pageErrors}</div>
      <br/>
      <div id="full-table" className="flex-display"
           style={{
             display: 'flex',
             flexDirection: 'row',
             gap: '129px',
             justifyContent: 'center',
           }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '838.16p',
            borderRadius: '10px',
            justifyContent: "space-between",
            alignItems: 'center',
          }}>
          <p className="subHeadingStyles">Mechanical Breakdown Insurance Quote</p>
        </div>

      </div>
      {props.inputValues.validAaMember === 'YES' && props.inputValues.aaMember === 'YES' &&
        <div id="full-table" className="flex-display"
             style={{
               display: 'flex',
               flexDirection: 'row',
               gap: '129px',
               justifyContent: 'center',
             }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '838.16p',
              borderRadius: '10px',
              justifyContent: "space-between",
              alignItems: 'center',
            }}>
            <p className="subSmallHeadingStyles">

              <GreenTickIcon/>&nbsp;We've applied your AA Member discount</p>
          </div>
        </div>}

      {/*mobile view*/
      }
      <div id="mobile-table"
           style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{maxWidth: '838.16px', width: "100%"}}>
          {/* Section 1: Compare Types of Cover through EV Battery Cover */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '-1px 1px 5px 6px rgba(0,0,0,0.06)',
              borderRadius: '5px',
              border: isAAPath ? '' : isVTNZPath ? '2px solid #E87722' : '2px solid #1851a3',
              marginBottom: '20px',
            }}>
            <div className="table-header"
                 style={
                   (isActive(props.cover2)) ||
                   (isActive(props.cover1)) ? {display: "flex"} : {}
                 }>
              <div className="aaBoldTextStyles" style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                color: isAAPath ? "black" : "white",
                flex: 2,
                height: '70px',
              }}>
                {/*Select your Term & Premium*/}
              </div>
              {(isActive(props.cover1)) && (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  textAlign:"center",
                  flex: 1,
                  paddingTop: '30px',
                  paddingBottom: '30px',
                }}>
                  <div className="CoverHeadingStyles1">
                    {props.cover1}
                    {/*Advantage*/}
                  </div>
                </div>)}
              {(isActive(props.cover2)) && (

                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: 'center',
                  textAlign:"center",
                  flex: 1,
                  paddingTop: '30px',
                  paddingBottom: '30px'
                }}>
                  <div className="CoverHeadingStyles1">
                    {props.cover2}
                    {/*Advantage Plus*/}
                  </div>
                </div>)}
            </div>
            <div
                style={{
                  height: '50px',
                  display: "flex",
                  backgroundColor: isAAPath ? '#63636380' : '#D6D4D6',
                }}
            >
              <div className="aaBoldTextStyles" style={{
                height: '50px',
                display: "flex",
                justifyContent: "flex-start",
                alignItems: 'center',
                color: isAAPath ? 'black' : isVTNZPath ? "#E87722" : "#1851a3",
                flex: 1,
                paddingLeft: "10px"
              }}>Claim limit
              </div>
            </div>
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                // height: "120px",
                // paddingTop: "15px",
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
              }}
              >
            <div
              style={{
                textAlign: 'center',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                maxHeight: window.innerWidth <= 768 ? '60px' : '60px',
              }}>
              <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
              <div className="benefitsListStyles"
                   style={{
                     // display: "flex",
                     alignItems: "center",
                     paddingLeft: "10px"
                   }}>Maximum per claim
                <TooltipTFAF
                  placement="top"
                  title={
                    <div>
                      Per Claim Limit<br/>
                      The most we will pay for any one claim is limited to the lesser of:<br/>
                      • the 'per claim limit' amount shown, less your excess; or<br/>
                      • the market value of your car at the date of your claim, less your excess.
                    </div>
                  }
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              </div>
                {(isActive(props.cover1)) && (
                  <div style={{
                    color: 'black',
                    justifyContent: "center",
                    flex: 1,
                  }}>
                    <div className="regularTextStyles coverStyle"
                         style={{display: "flex", flexDirection: "column", paddingTop: "25px"}}>
                      {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                        <CheckCircleIconLight/>}
                      {getClaimLimit(props.cover1, excess.get(props.cover1))}
                    </div>
                  </div>)}
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%",
                      flex: 1
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "25px"}}>
                        {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                          <CheckCircleIconLight/>}
                        {getClaimLimit(props.cover2, excess.get(props.cover2))}
                      </div>
                    </div>
                  </>)}
            </div>
            <div className="benefitsListSubHeadingStyles" style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "10px",
              color:"#696868"
            }}>
              You may lodge multiple claims. The total of all claims is limited to the vehicle's market value.
            </div>
            </div>
            <div
                id="benefits-section"
                style={{
                  height: '50px',
                  display: "flex",
                  backgroundColor: isAAPath ? '#63636380' : '#D6D4D6',
                  cursor: window.innerWidth <= 767 ? 'pointer' : 'default'
                }}
                onClick={() => {
                  if (window.innerWidth <= 767) {
                    setBenefitsCollapsed(!benefitsCollapsed);
                  }
                }}
            >
              <div className="aaBoldTextStyles" style={{
                height: '50px',
                display: "flex",
                justifyContent: "flex-start",
                alignItems: 'center',
                color: isAAPath ? 'black' : isVTNZPath ? "#E87722" : "#1851a3",
                flex: 1,
                paddingLeft: "10px"
              }}>Benefits
                {window.innerWidth <= 767 && (
                  <span style={{
                    marginLeft: "10px",
                    fontSize: '22px',
                  }}>
                    {benefitsCollapsed ? '▸' : '▾'}
                  </span>
                )}
              </div>
            </div>
            {!benefitsCollapsed && (
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                // height: "120px",
                // paddingTop: "15px",
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
              }}
            >
            <div
              style={{
                textAlign: 'center',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                maxHeight: window.innerWidth <= 768 ? '60px' : '55px',
              }}>
              <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
                <div className="benefitsListStyles"
                     style={{
                       display: "flex",
                       alignItems: "center",
                       paddingLeft: "10px",
                     }}>Towing
                  <TooltipTFAF
                    placement="top"
                    title="Following a breakdown we will refund you the costs of towing your car, either home or to an authorised repairer, whichever is closer, up to the amount shown."
                  >
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
              </div>
                {(isActive(props.cover1)) && (
                  <div style={{
                    color: 'black',
                    flex: 1,
                    justifyContent: "center",
                  }}>
                    <div className="regularTextStyles coverStyle"
                         style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                      {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                        <CheckCircleIconLight/>}
                      <span className="regularTextStyles"> $300</span>
                    </div>
                  </div>)}
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%",
                      flex: 1
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                          <CheckCircleIconLight/>}
                        <span className="regularTextStyles"> $300 </span>
                      </div>
                    </div>
                  </>
                )}
            </div>
              <div className="benefitsListSubHeadingStyles" style={{
                display: "flex",
                flex: 2,
                alignItems: "center",
                paddingLeft: "10px",
                color:"#696868"
              }}>
                An additional $300 per claim, to help getting your car to a repairer
              </div>
            </div>
            )}

            {!benefitsCollapsed && (
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                // height: "120px",
                // paddingTop: "15px",
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
              }}
            >
            <div
              style={{
                textAlign: 'center',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                maxHeight: '50px'
              }}>
              <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
                <div className="benefitsListStyles"
                     style={{
                       alignItems: "center",
                       paddingLeft: "10px",
                     }}>Access & Comfort
                  <TooltipTFAF
                    placement="top"
                    title={
                      <div>
                        We'll pay the costs of repairing or replacing the following parts:<br/>
                        • ambient lighting;<br/>
                        • automatic opening tailgates and sliding doors;<br/>
                        • convertible roof components, excluding glass, panel, paintwork and trim;<br/>
                        • disability and mobility seats, lifts, ramps and components, excluding upholstery, panel,
                        paintwork and trim;<br/>
                        • door locks, handles and hinges;<br/>
                        • electric folding tow bars;<br/>
                        • keys and remotes;<br/>
                        • seating and seating mechanisms (memory adjustments, heating, ventilation, massage, etc.);<br/>
                        • soft-close doors and trunk systems; and<br/>
                        • sunroof components, excluding glass, misalignment, panel, paintwork, seals and trim.<br/><br/>
                        If the option is not included, then there is no cover for a breakdown of these parts.
                      </div>
                    }
                  >
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
              </div>
                {(isActive(props.cover1)) && (
                  <div style={{
                    color: 'black',
                    flex: 1,
                    justifyContent: "center",
                  }}>
                    <div className="regularTextStyles coverStyle"
                         style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                      <CrossCircleIconLight/>
                    </div>
                  </div>)}
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%",
                      flex: 1
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                          <CheckCircleIconLight/>}
                      </div>
                    </div>
                  </>
                )}
            </div>
              <div className="benefitsListSubHeadingStyles" style={{
                display: "flex",
                flex: 2,
                paddingLeft: "10px",
                color:"#696868"
              }}>
                Cover for interior comfort, doors, roof systems, keys & remotes
              </div>
            </div>
            )}
            {!benefitsCollapsed && (
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                // height: "120px",
                // paddingTop: "15px",
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
              }}
            >
            <div
              style={{
                textAlign: 'center',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                maxHeight: '50px'
              }}>
              <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
                <div className="benefitsListStyles"
                     style={{
                       alignItems: "center",
                       paddingLeft: "10px",
                     }}>Assistance & Safety
                  <TooltipTFAF
                    title={<div>
                      We’ll pay the costs of repairing or replacing the following parts:<br/>
                      • adaptive (autonomous) cruise control systems;<br/>
                      • automatic parking systems;<br/>
                      • automatic roll-over bar components:<br/>
                      • blind spot monitoring systems;<br/>
                      • driver drowsiness detection systems;<br/>
                      • emergency braking systems;<br/>
                      • head-up display systems;<br/>
                      • lane departure warning systems;<br/>
                      • mirror components;<br/>
                      • radars and dashboard cameras;<br/>
                      • rear-view, front, side and 360-degree cameras;<br/>
                      • safety airbag systems;<br/>
                      • seat belt systems;<br/>
                      • traffic sign recognition systems;<br/>
                      • tyre pressure monitoring systems; and<br/>
                      • visual and audible parking systems.<br/><br/>

                      If the option is not included, then there is no cover for a breakdown of these parts.

                    </div>}
                  ><i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
              </div>
                {(isActive(props.cover1)) && (
                  <div style={{
                    color: 'black',
                    flex: 1,
                    justifyContent: "center",
                  }}>
                    <div className="regularTextStyles coverStyle"
                         style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                      <CrossCircleIconLight/>
                    </div>
                  </div>)}
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%",
                      flex: 1
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                          <CheckCircleIconLight/>}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="benefitsListSubHeadingStyles" style={{
                paddingLeft: "10px",
                display: 'flex', flex: 2,
                color:"#696868"
              }}>Cover for driver assistance, safety, parking, visibility & monitoring systems
              </div>
            </div>
            )}

            {!benefitsCollapsed && (
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                // height: "120px",
                // paddingTop: "15px",
              }}
            >
            <div
              style={{
                textAlign: 'center',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                maxHeight: '50px'
              }}>
              <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
                <div className="benefitsListStyles"
                     style={{
                       display: "flex",
                       alignItems: "center",
                       paddingLeft: "10px"
                     }}>Entertainment
                  <TooltipTFAF
                    placement="top"
                    title={<div>
                      We’ll pay the costs of repairing or replacing the following parts:<br/>
                      • entertainment systems;<br/>
                      • navigation, communication, Bluetooth, audio; and<br/>
                      • audio speakers.<br/><br/>

                      If the option is not included, then there is no cover for a breakdown of these parts.

                    </div>}
                  >
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
              </div>
                {(isActive(props.cover1)) && (
                  <div style={{
                    color: 'black',
                    flex: 1,
                    justifyContent: "center",
                  }}>
                    <div className="regularTextStyles coverStyle"
                         style={{display: "flex", flexDirection: "column", alignItems: "center",}}>
                      <CrossCircleIconLight/>
                    </div>
                  </div>)}
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%",
                      flex: 1
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                          <CheckCircleIconLight/>}
                      </div>
                    </div>
                  </>
                )}
            </div>
              <div className="benefitsListSubHeadingStyles" style={{
                display: "flex",
                flex: 2,
                alignItems: "center",
                paddingLeft: "10px",
                color:"#696868"
              }}>
                Cover for navigation, communication, audio & entertainment systems
              </div>
            </div>
            )}

            {!benefitsCollapsed && (
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                // height: "120px",
                // paddingTop: "15px",
              }}
            >
            <div
              style={{
                textAlign: 'center',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                maxHeight: '50px'
              }}>
              <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
                <div className="benefitsListStyles"
                     style={{
                       display: "flex",
                       alignItems: "center",
                       paddingLeft: "10px",
                       // paddingTop: "15px",
                     }}>Performance
                  <TooltipTFAF
                    placement="top"
                    title={
                      <div>
                        We’ll pay the costs of repairing or replacing the following parts:<br/>
                        • automatic spoilers<br/>
                        • height adjustable, adaptive, active and semi-active suspension systems; and<br/>
                        • shock absorbers.<br/><br/>

                        If the option is not included, then there is no cover for a breakdown of these parts.
                      </div>
                    }
                  >
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
              </div>
                {(isActive(props.cover1)) && (
                  <div style={{
                    color: 'black',
                    flex: 1,
                    justifyContent: "center",
                  }}>
                    <div className="regularTextStyles coverStyle"
                         style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                      <CrossCircleIconLight/>
                    </div>
                  </div>)}
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%",
                      flex: 1
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                          <CheckCircleIconLight/>}
                      </div>
                    </div>
                  </>
                )}
            </div>
              <div className="benefitsListSubHeadingStyles" style={{
                display: "flex",
                flex: 2,
                alignItems: "center",
                paddingLeft: "10px",
                color:"#696868"
              }}>
                Cover for spoilers, suspension systems & shock absorbers
              </div>
            </div>
            )}

            {!benefitsCollapsed && (props.inputValues.propulsionOptions.includes('ELECTRIC') || props.inputValues.propulsionOptions.includes('HYBRID')) && (
              <div
                style={{
                  background: getNextBackgroundColorMobile(),
                  color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                  // height: "120px",
                  // paddingTop: "15px",
                }}
              >
              <div
                style={{
                  textAlign: 'center',
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: 'center',
                  maxHeight: window.innerWidth <= 768 ? '80px' : '55px',
                  paddingBottom: '10px',
                }}>
                <div style={{display: 'flex', flex: 2, flexDirection: 'column'}}>
                  <div className="benefitsListStyles"
                       style={{
                         // display: "flex",
                         paddingLeft: "10px",
                         // paddingTop: "15px",
                       }}>EV Battery Cover
                    <TooltipTFAF
                      placement="top"
                      title={<div>
                        We’ll pay the cost of repair or replacement of your EV’s auxiliary engine and drive unit
                        (inverter); and dual charger and electric vehicle battery.<br/><br/>

                        For Advantage MBI the total for all claims over the entire policy period is:<br/>
                        • $5,000 less the excess if your vehicle is aged up to and including 10 years at the time of the
                        repair or replacement; or<br/>
                        • $2,500 less the excess if your vehicle is aged over 10 years at the time of the repair or
                        replacement.<br/><br/>

                        For Advantage Plus MBI the total for all claims over the entire policy period is:<br/>
                        • $10,000 less the excess if your vehicle is aged up to and including 10 years at the time of
                        the repair or replacement; or<br/>
                        • $5,000 less the excess if your vehicle is aged over 10 years at the time of the repair or
                        replacement.<br/>
                      </div>}
                    >
                      <i className="fa fa-info-circle"/>
                    </TooltipTFAF>
                  </div>
                </div>
                  {(isActive(props.cover1)) && (
                    <div style={{
                      color: 'black', flex: 1, justifyContent: "center",
                    }}>
                      <div className="regularTextStyles coverStyle"
                           style={{
                             display: "flex", flexDirection: "column", paddingTop: '25px'
                           }}>
                        {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                          <CheckCircleIconLight/>}
                        <span className="regularTextStyles">$2,500 - $5,000</span>
                      </div>
                    </div>)}

                  {(isActive(props.cover2)) && (
                    <>
                      {isActive(props.cover2) && isActive(props.cover1) ?
                        <div className="divider" style={{height: "100px"}}></div> : <></>}
                      <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        color: 'black',
                        width: "100%",
                        flex: 1
                      }}>
                        <div className="regularTextStyles"
                             style={{
                               display: "flex",
                               flexDirection: "column",
                               alignItems: "center",
                               paddingTop: '25px',
                             }}>
                          {isAAPath ? <CheckCircleIconLight_AA/> : isVTNZPath ? <CheckCircleIconVTNZ/> :
                            <CheckCircleIconLight/>}
                          <span className="regularTextStyles">$5,000 - $10,000</span>
                        </div>
                      </div>
                    </>
                  )}
              </div>
                <div className="benefitsListSubHeadingStyles" style={{
                  display: "flex",
                  flex: 2,
                  paddingLeft: "10px",
                  color:"#696868"
                }}>
                  Protection for battery related problems up to the defined limit
                </div>
              </div>)}
            {benefitsCollapsed && (<div style={{
              height: '2px',
              display: "flex"
            }}></div>)}
          </div>

          {/* Section 2: Select your premium based on term & product through Travel Disruption */}
          <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '-1px 1px 5px 6px rgba(0,0,0,0.06)',
                borderRadius: '5px',
                border: isAAPath ? '' : isVTNZPath ? '2px solid #E87722' : '2px solid #1851a3',
                marginBottom: '20px',
              }}>
            <div className="mobile-cover-display"
                 style={{
                   height: '110px',
                   display: "flex"
                 }}
            >
              <div className="subHeadingStyles table-header subHeadingWhite"
                   style={{
                     display: "flex",
                     justifyContent: "flex-start",
                     alignItems: 'center',
                     paddingLeft: '10px',
                     flex: 1,
                   }}>
                Select your premium based on term & product
              </div>
            </div>
            <table className="mobile-cover-display" style={{
              width: "100%",
              borderCollapse: "collapse",
              display: (isActive(props.cover2)) || (isActive(props.cover1)) ? "table" : "none"
            }}>
              <thead>
              <tr>
                <th className="aaBoldTextStyles" style={{
                  // color: isAAPath ? "black" : "white",
                  width: "40%",
                  height: '100px',
                  verticalAlign: "middle",
                  paddingLeft: "10px"
                }}>
                  {/*Select your Term & Premium*/}
                </th>
                {(isActive(props.cover1)) && (
                  <th style={{
                    width: "30%",
                    paddingTop: '30px',
                    paddingBottom: '30px',
                    verticalAlign: "top",
                    textAlign: "left"
                  }}>
                    <div className="CoverHeadingStyles CoverHeadingStyles2">
                      {props.cover1}
                      {/*Advantage*/}
                    </div>
                  </th>
                )}
                {(isActive(props.cover2)) && (
                  <th style={{
                    width: "30%",
                    paddingTop: '30px',
                    paddingBottom: '30px',
                    verticalAlign: "top",
                    textAlign: "left"
                  }}>
                    <div className="CoverHeadingStyles CoverHeadingStyles2">
                      {props.cover2}
                      {/*Advantage Plus*/}
                    </div>
                  </th>
                )}
              </tr>
              </thead>
            </table>
            {/*this is premium table starts*/}
            <table className="benefitsListStyles" style={{
              width: "100%",
              background: "#F3F4F6",
              paddingTop: "10px",
              borderCollapse: "collapse"
            }}>
              <tbody>
              {["12", "24", "36"].map(term => {
                const cover1Premium = isActive(props.cover1)
                  ? getPremium1(props.cover1, term)
                  : null;
                const cover2Premium = isActive(props.cover2)
                  ? getPremium1(props.cover2, term)
                  : null;

                const showRow = (isActive(props.cover1) && cover1Premium) || (isActive(props.cover2) && cover2Premium);
                if (!showRow) return null;

                return (
                  <tr key={term}>
                    {/* Column 1: Cover years */}
                    <td
                      className="placeholderTextStyles"
                      style={{
                        paddingLeft: "10px",
                        paddingBottom: "12px",
                        verticalAlign: "middle",
                        width: "40%",
                      }}
                    >
                      Cover for {term / 12} {term === "12" ? "year " : "years"}
                    </td>

                    {/* Column 2: Cover1 Premium */}
                    <td className="regularBoldTextStyles" style={{
                      paddingBottom: "12px",
                      verticalAlign: "middle",
                      width: "30%",
                      textAlign: "left",
                    }}>
                      {isActive(props.cover1) && cover1Premium && (
                            <Form.Check
                              type="radio"
                              className="quoteCheckbox"
                              label={
                                <span>
                                  {cover1Premium.discountedAmount !== null ? (
                                    <>
                                      <span style={{textDecoration: "line-through", marginRight: "8px"}}>
                                        {cover1Premium.formattedNonDiscountedAmount}
                                      </span>
                                      <br/>
                                      <span>{cover1Premium.formattedRetailAmount}</span>
                                    </>
                                  ) : (
                                    <span>{cover1Premium.formattedRetailAmount}</span>
                                  )}
                                </span>
                              }
                              id={`cover1_${term}`}
                              onChange={() => handleRadioChange(props.cover1, term)}
                              checked={
                                props.inputValues.selectedTermAndCover?.coverName === props.cover1 &&
                                props.inputValues.selectedTermAndCover?.term === term
                              }
                            />
                      )}
                    </td>

                    {/* Column 3: Cover2 Premium */}
                    {isActive(props.cover2) && cover2Premium && (
                    <td className="regularBoldTextStyles"
                        style={{
                      paddingBottom: "12px",
                      verticalAlign: "middle",
                      width: "30%",
                      // textAlign: "center"
                    }}>

                            <Form.Check
                              type="radio"
                              className="quoteCheckbox"
                              label={
                                <span>
                                  {cover2Premium.discountedAmount !== null ? (
                                    <>
                                      <span style={{textDecoration: "line-through", marginRight: "8px"}}>
                                        {cover2Premium.formattedNonDiscountedAmount}
                                      </span>
                                      <br/>
                                      <span>{cover2Premium.formattedRetailAmount}</span>
                                    </>
                                  ) : (
                                    <span>{cover2Premium.formattedRetailAmount}</span>
                                  )}
                                </span>
                              }
                              id={`cover2_${term}`}
                              onChange={() => handleRadioChange(props.cover2, term)}
                              checked={
                                props.inputValues.selectedTermAndCover?.coverName === props.cover2 &&
                                props.inputValues.selectedTermAndCover?.term === term
                              }
                            />
                    </td>
                    )}
                  </tr>
                );
              })}
              </tbody>
            </table>

            {/*this is premium table ends*/}

            <div className="regularBlueTextStyles regularOrangeTextStyles"
                 style={{paddingLeft: "10px", fontSize: '10px', background: "#F3F4F6",}}>The
              premium is a single, non-recurring
              payment covering the entire
              policy
              term.
            </div>
            <div
                style={{
                  height: '50px',
                  display: "flex",
                  backgroundColor: isAAPath ? '#63636380' : '#D6D4D6',
                }}
            >
              <div className="aaBoldTextStyles" style={{
                height: '50px',
                display: "flex",
                justifyContent: "flex-start",
                alignItems: 'center',
                color: isAAPath ? 'black' : isVTNZPath ? "#E87722" : "#1851a3",
                paddingLeft: "10px"
              }}>Select your excess
              </div>
            </div>
            {/* Excess section using table structure */}


            <table className="benefitsListStyles" style={{
              width: "100%",
              background: "#F3F4F6",
              paddingTop: "10px",
              borderCollapse: "collapse"
            }}>
              <tbody>
              <tr>
                {/* Column 1: Excess label */}
                <td
                  className="boldTextStyles"
                  style={{
                    paddingLeft: "10px",
                    paddingBottom: "12px",
                    verticalAlign: "middle",
                    width: "40%",
                    color: isAAPath || isVTNZPath ? 'black' : "#1851a3",
                  }}
                >
                  Excess
                </td>

                {/* Column 2: Cover1 Excess */}
                <td className="regularBoldTextStyles" style={{
                  paddingBottom: "12px",
                  verticalAlign: "middle",
                  width: "30%",
                  textAlign: "left"
                }}>
                  {isActive(props.cover1) && (
                      <div
                        className={`mobile-cover-excess-container ${getExcess(props.cover1, null).length === 1 ? 'single-option' : ''}`}>
                        {getExcess(props.cover1, null).map((ex, index) => (
                          <Form.Check
                            key={index}
                            type="radio"
                            className='regularBoldTextStyles'
                            label={'$' + ex}
                            name='cover1_excess'
                            disabled={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover2}
                            id={props.cover1 + '_' + ex}
                            onChange={() => handleExcessChange(props.cover1, ex)}
                            checked={
                              (props.inputValues.selectedTermAndCover?.coverName === props.cover1 && props.inputValues.excess === ex) ||
                              (props.inputValues.selectedTermAndCover?.coverName === props.cover2 &&
                                (isFirstTime
                                    ? defaultCoverExcess.get(props.cover1) === ex
                                    : (excess.get(props.cover1) ?? defaultCoverExcess.get(props.cover1)) === ex
                                )
                              ) ||
                              (isFirstTime && defaultCoverExcess.get(props.cover1) === ex)
                            }
                          />
                        ))}
                    </div>
                  )}
                </td>

                {/* Column 3: Cover2 Excess */}
                {isActive(props.cover2) && (
                <td className="regularBoldTextStyles" style={{
                  paddingBottom: "12px",
                  verticalAlign: "middle",
                  width: "30%",
                }}>
                      <div
                        className={`mobile-cover-excess-container ${getExcess(props.cover2, null).length === 1 ? 'single-option' : ''}`}>
                        {getExcess(props.cover2, null).map((ex, index) => (
                          <Form.Check
                            key={index}
                            type="radio"
                            className='regularBoldTextStyles'
                            label={'$' + ex}
                            name='cover2_excess'
                            disabled={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover1}
                            id={props.cover2 + '_' + ex}
                            onChange={() => handleExcessChange(props.cover2, ex)}
                            checked={
                              (props.inputValues.selectedTermAndCover?.coverName === props.cover2 && props.inputValues.excess === ex) ||
                              (props.inputValues.selectedTermAndCover?.coverName === props.cover1 &&
                                (isFirstTime
                                    ? defaultCoverExcess.get(props.cover2) === ex
                                    : (excess.get(props.cover2) ?? defaultCoverExcess.get(props.cover2)) === ex
                                )
                              ) || (isFirstTime && defaultCoverExcess.get(props.cover2) === ex)
                            }
                          />
                        ))}
                    </div>
                </td>
                )}
              </tr>
              </tbody>
            </table>

            <div className="benefitsListSubHeadingStyles" style={{
              background: "#F3F4F6",
              paddingLeft: "10px",
              paddingBottom: "10px",
              color: "#696868"
            }}>
              To be paid by you per claim
            </div>
            <div
                 style={{
                   height: '50px',
                   display: "flex",
                   backgroundColor: isAAPath ? '#63636380' : '#D6D4D6',
                 }}
            >
              <div className="aaBoldTextStyles"
                   style={{
                     height: '50px',
                     display: "flex",
                     justifyContent: "flex-start",
                     alignItems: 'center',
                     color: isAAPath ? 'black' : isVTNZPath ? "#E87722" : "#1851a3",
                     flex: 1,
                     paddingLeft: "10px"
                   }}>
                Select your additional benefits
              </div>
            </div>
            {(props.inputValues.validAaMember !== 'YES' && props.inputValues.source !== 'VTNZ') && (
                <>
                  <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                // height: "120px"
              }}>
              <div
                style={{display: 'flex', flex: 1, flexDirection: 'column', paddingTop: '15px'}}>
                <div style={{display: 'flex', height: '45px'}}>
                <div className="benefitsListStyles"
                     id="aa-roadservice-optional-benefits"
                     style={{
                       display: "flex",
                       flex: 1,
                       paddingLeft: '10px',
                     }}>AA Roadservice
                  <TooltipTFAF
                    placement="top"
                    title={
                      <div>
                        Covers 24/7, 365 days year assistance with towing, flat battery, lockouts, lost keys, flat tyres
                        and out of fuel. If your car breaks down, whoever is driving it at the time can call the AA and
                        get roadside assistance.<br/><br/>

                        Applies in the North Island, Waiheke Island and South Island only.<br/><br/>

                        This Roadside Assistance Cover is by AA Roadservice, provided and administered by The New
                        Zealand Automobile Association Inc. on our behalf.

                      </div>
                    }>
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
                  <div style={{
                    display: "flex", flex: 1, justifyContent: "center"
                  }}>
                    <Switch onColor={isVTNZPath ? "#E87722" : isAAPath ? "#0d59bf" : "#43A435"}
                            onHandleColor="#FFFFFF"
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checkedHandleIcon={
                              <div
                                id="aa-roadservice-id"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                  width: "100%",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke={isVTNZPath ? "#E87722" : isAAPath ? "#0d59bf" : "#43A435"}
                                  strokeWidth="3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              </div>
                            }
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                            id="aa-roadservice-switch"
                            checked={aaRoadService}
                            onChange={handleAARoadService}
                      // onChange={handleAddressSwitchChange} // Call handleSwitchChange when the switch state changes
                      // checked={props.inputValues.addressSwitchEnabled} // Pass the switch state to the checked prop
                    />
                  </div>

                </div>
                <div className="benefitsListSubHeadingStyles" style={{
                  display: "flex",
                  flex: 1,
                  paddingLeft: '10px',
                  color:"#696868"
                }}>
                  24/7 assistance for when the unexpected happens
                </div>
              </div>
            </div>
                </>)}
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                // height: "120px"
              }}>
              <div style={{display: 'flex', flex: 1, flexDirection: 'column', paddingTop: '15px'}}>
                <div style={{display: 'flex', height: '45px'}}>
                <div className="benefitsListStyles"
                     id="consumables-optional-benefits"
                     style={{
                       display: "flex",
                       flex: 1,
                       paddingLeft: '10px'
                     }}>Consumables
                  <TooltipTFAF
                    placement="top"
                    title="As part of your claim we’ll pay the costs of consumable items, like cleaners, coolants, fluids, filters oil(s), sealants and solvents, replacement as part of your claim, up to the Consumables Cover amount shown, per claim."
                  >
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
                  <div style={{
                    display: "flex", flex: 1, justifyContent: "center"
                  }}>
                    <Switch onColor={isVTNZPath ? "#E87722" : isAAPath ? "#0d59bf" : "#43A435"}
                            onHandleColor="#FFFFFF"
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checkedHandleIcon={
                              <div
                                id="consumables-id"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                  width: "100%",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke={isVTNZPath ? "#E87722" : isAAPath ? "#0d59bf" : "#43A435"}
                                  strokeWidth="3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              </div>
                            }
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                            id="consumables-switch"
                            checked={consumables}
                            onChange={handleConsumables}
                      // onChange={handleAddressSwitchChange} // Call handleSwitchChange when the switch state changes
                      // checked={props.inputValues.addressSwitchEnabled} // Pass the switch state to the checked prop
                    />
                  </div>
                </div>
                <div className="benefitsListSubHeadingStyles" style={{
                  display: "flex",
                  flex: 1,
                  paddingLeft: '10px',
                  color:"#696868"
                }}>
                  We’ll pay up to $300 for consumables per claim
                </div>
              </div>
            </div>
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                // height: "120px"
              }}>
              <div style={{display: 'flex', flex: 1, flexDirection: 'column', paddingTop: '15px'}}>
                <div style={{display: 'flex', height: '45px'}}>
                <div className="benefitsListStyles"
                     id="travel-disruption-optional-benefits"
                     style={{
                       display: "flex",
                       flex: 1,
                       paddingLeft: '10px'
                     }}>Travel Disruption
                  <TooltipTFAF
                    placement="top"
                    title={
                      <div>
                        Following a breakdown 100km or more from home, where the repair will take longer than 24 hours.
                        We’ll refund, up to the amount shown:<br/>
                        • the costs for accommodation, rental car hire or return home travel; and/ or<br/>
                        • the cost of returning your vehicle to home or another location convenient to you, whichever is
                        closer.
                      </div>
                    }>
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
                  <div style={{
                    display: "flex", flex: 1, justifyContent: "center",
                    alignItems: "center"
                  }}>
                    <Switch onColor={isVTNZPath ? "#E87722" : isAAPath ? "#0d59bf" : "#43A435"}
                            onHandleColor="#FFFFFF"
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checkedHandleIcon={
                              <div
                                id="travel-disruption-id"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                  width: "100%",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke={isVTNZPath ? "#E87722" : isAAPath ? "#0d59bf" : "#43A435"}
                                  strokeWidth="3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              </div>
                            }
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={20}
                            width={48}
                            className="react-switch"
                            id="travel-disruption-switch"
                            checked={travelDisruption}
                            onChange={handleTravelDisruption}
                      // onChange={handleAddressSwitchChange} // Call handleSwitchChange when the switch state changes
                      // checked={props.inputValues.addressSwitchEnabled} // Pass the switch state to the checked prop
                    />
                  </div>
                </div>
                <div className="benefitsListSubHeadingStyles" style={{
                  display: "flex",
                  flex: 1,
                  paddingLeft: '10px',
                  color:"#696868"
                }}>
                  We’ll pay up to $1,200 for repatriation, accommodation & return home travel
                </div>
              </div>
            </div>
            {/*<div style={{display: "flex", background: isAAPath ? "white" : '#F3F4F6'}}><br/></div>*/}

            {(props.inputValues.selectedTermAndCover.coverName) && (
                <div className="scrollPremium" style={{
                  background: isAAPath ? '#ffd400' : '#1851a3',
                  color: isAAPath ? '#1851A3' : "white",
                }}>
                  <div className="table-header" style={{
                    padding: '5px 24px 0 24px',
                    display: "flex",
                    justifyContent: "space-between",
                  }}>
                    <div className="placeholderRegularTextStyles" style={{
                      display: "flex",
                      flexDirection: "column",
                      fontWeight: '700'
                    }}>
                      <div className="subHeadingWhiteTextStyles regularSubHeadingStyles table-header">Your Premium
                      </div>
                    </div>
                    <div
                      className="subHeadingWhiteTextStyles regularSubHeadingStyles table-header">{getPremium1(props.inputValues.selectedTermAndCover.coverName, props.inputValues.selectedTermAndCover.term).formattedRetailAmount}</div>
                  </div>
                  <div
                    className="placeholderTextStyles_12px table-header"
                      style={{
                        padding: '0px 24px 10px 24px',
                      }}
                  >
                    {props.inputValues.selectedTermAndCover.coverName} | {props.inputValues.selectedTermAndCover.term !== undefined && <>
                    {props.inputValues.selectedTermAndCover.term / 12} {props.inputValues.selectedTermAndCover.term / 12 === 1 ? ' year term' : ' year term'} </>}
                    | ${props.inputValues.excess} excess
                  </div>
              </div>)}
          </div>

          {/* Section 3: Download policy book */}

          <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '-1px 1px 5px 6px rgba(0,0,0,0.06)',
                    borderRadius: '5px',
                    border: isAAPath ? '' : isVTNZPath ? '2px solid #E87722' : '2px solid #1851a3',
                    marginBottom: '20px',
                  }}>
                <div className="mobile-cover-display"
                     style={{
                       height: '110px',
                       display: "flex"
                     }}
                >
                  <div className="subHeadingStyles table-header subHeadingWhite"
                       style={{
                         display: "flex",
                         justifyContent: "flex-start",
                         alignItems: 'center',
                         paddingLeft: '10px',
                         flex: 1,
                       }}>
                    View policy wording
                  </div>
                </div>
            {(props.cover1 === 'Advantage' || props.cover2 === 'Advantage Plus') && (
                <div
                    style={{
                      background: getNextBackgroundColorMobile(),
                      color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                    }}
                >
                  <div
                      style={{
                        paddingLeft: '10px',
                        paddingTop: "10px",
                        paddingBottom: "10px"
                      }}>
                      {(isActive(props.cover1)) && (
                        <div className="regularTextStyles"
                                 style={{
                                   textDecoration: 'underline',
                                   cursor: 'pointer',
                                   color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                                 }}>
                              <a
                                href={
                                  props.inputValues.source === 'GASPY'
                                    ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/gaspy_advantage.pdf"
                                    : isVTNZPath
                                      ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/VTNZ_advantage.pdf"
                                      : isAAPath ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/AA_advantage.pdf"
                                        : "https://docs.autosure.co.nz/policy_books/autosure/mbi/advantage.pdf"
                                }
                                  target="_blank" rel="noopener noreferrer"
                                className="text-decoration-none"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px", // prevents &nbsp;&nbsp;
                                  color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                                }}
                              >
                                <svg width="17" height="17" viewBox="0 0 18 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg"
                                     className="svg-break-on-mobile">
                                  <path fillRule="evenodd" clipRule="evenodd"
                                        d="M0.350098 18.4004C0.350098 17.7376 0.887356 17.2004 1.5501 17.2004H15.9501C16.6128 17.2004 17.1501 17.7376 17.1501 18.4004C17.1501 19.0631 16.6128 19.6004 15.9501 19.6004H1.5501C0.887356 19.6004 0.350098 19.0631 0.350098 18.4004ZM4.30157 9.15186C4.7702 8.68323 5.53 8.68323 5.99862 9.15186L7.5501 10.7033L7.5501 1.60039C7.5501 0.93765 8.08735 0.400391 8.7501 0.400391C9.41284 0.400391 9.9501 0.937648 9.9501 1.60039L9.9501 10.7033L11.5016 9.15186C11.9702 8.68323 12.73 8.68323 13.1986 9.15186C13.6673 9.62049 13.6673 10.3803 13.1986 10.8489L9.59862 14.4489C9.37358 14.674 9.06836 14.8004 8.7501 14.8004C8.43184 14.8004 8.12661 14.674 7.90157 14.4489L4.30157 10.8489C3.83294 10.3803 3.83294 9.62049 4.30157 9.15186Z"
                                        fill={isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'}/>
                                </svg>
                                {props.cover1} policy wording</a>
                              {/*&nbsp;&nbsp;Download Advantage policy book*/}
                        </div>)}
                      {(isActive(props.cover2)) && (
                          <>
                            {isActive(props.cover2) && isActive(props.cover1) ?
                                <div className="divider"></div> : <></>}
                              <div className="regularTextStyles"
                                   style={{
                                     paddingTop: "10px",
                                     textDecoration: 'underline',
                                     cursor: 'pointer',
                                     color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                                   }}>
                                <a
                                  href={
                                    props.inputValues.source === 'GASPY'
                                      ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/gaspy_advantageplus.pdf"
                                      : isVTNZPath
                                        ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/VTNZ_advantageplus.pdf"
                                        : isAAPath ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/AA_advantageplus.pdf"
                                          : "https://docs.autosure.co.nz/policy_books/autosure/mbi/advantage_plus.pdf"
                                  }
                                    target="_blank" rel="noopener noreferrer"
                                  className="text-decoration-none"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px", // prevents &nbsp;&nbsp;
                                    color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                                  }}
                                >
                                  <svg width="17" height="17" viewBox="0 0 18 20" fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                       className="svg-break-on-mobile">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M0.350098 18.4004C0.350098 17.7376 0.887356 17.2004 1.5501 17.2004H15.9501C16.6128 17.2004 17.1501 17.7376 17.1501 18.4004C17.1501 19.0631 16.6128 19.6004 15.9501 19.6004H1.5501C0.887356 19.6004 0.350098 19.0631 0.350098 18.4004ZM4.30157 9.15186C4.7702 8.68323 5.53 8.68323 5.99862 9.15186L7.5501 10.7033L7.5501 1.60039C7.5501 0.93765 8.08735 0.400391 8.7501 0.400391C9.41284 0.400391 9.9501 0.937648 9.9501 1.60039L9.9501 10.7033L11.5016 9.15186C11.9702 8.68323 12.73 8.68323 13.1986 9.15186C13.6673 9.62049 13.6673 10.3803 13.1986 10.8489L9.59862 14.4489C9.37358 14.674 9.06836 14.8004 8.7501 14.8004C8.43184 14.8004 8.12661 14.674 7.90157 14.4489L4.30157 10.8489C3.83294 10.3803 3.83294 9.62049 4.30157 9.15186Z"
                                          fill={isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'}/>
                                  </svg>
                                  {props.cover2} policy wording</a>
                                {/*&nbsp;&nbsp;Download Advantage Plus policy book*/}
                            </div>
                          </>
                      )}
                  </div>
                </div>
            )}
            {(props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER') && (props.cover1 !== 'Advantage' && props.cover2 !== 'Advantage Plus') && (
              <div
                style={{
                  background: getNextBackgroundColorMobile(),
                  color: isAAPath || isVTNZPath ? 'black' : '#1851a3',
                }}
              >
                <div
                  style={{
                    paddingLeft: '10px',
                    paddingTop: "10px",
                    paddingBottom: "10px"
                  }}>
                  {(isActive(props.cover1)) && (
                    <div className="regularTextStyles"
                         style={{
                           textDecoration: 'underline',
                           cursor: 'pointer',
                           color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                         }}>
                      <a
                        href={policyLink()}
                        target="_blank" rel="noopener noreferrer"
                        className="text-decoration-none"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px", // prevents &nbsp;&nbsp;
                          color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                        }}
                      >
                        <svg width="17" height="17" viewBox="0 0 18 20" fill="none"
                             xmlns="http://www.w3.org/2000/svg"
                             className="svg-break-on-mobile">
                          <path fillRule="evenodd" clipRule="evenodd"
                                d="M0.350098 18.4004C0.350098 17.7376 0.887356 17.2004 1.5501 17.2004H15.9501C16.6128 17.2004 17.1501 17.7376 17.1501 18.4004C17.1501 19.0631 16.6128 19.6004 15.9501 19.6004H1.5501C0.887356 19.6004 0.350098 19.0631 0.350098 18.4004ZM4.30157 9.15186C4.7702 8.68323 5.53 8.68323 5.99862 9.15186L7.5501 10.7033L7.5501 1.60039C7.5501 0.93765 8.08735 0.400391 8.7501 0.400391C9.41284 0.400391 9.9501 0.937648 9.9501 1.60039L9.9501 10.7033L11.5016 9.15186C11.9702 8.68323 12.73 8.68323 13.1986 9.15186C13.6673 9.62049 13.6673 10.3803 13.1986 10.8489L9.59862 14.4489C9.37358 14.674 9.06836 14.8004 8.7501 14.8004C8.43184 14.8004 8.12661 14.674 7.90157 14.4489L4.30157 10.8489C3.83294 10.3803 3.83294 9.62049 4.30157 9.15186Z"
                                fill={isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'}/>
                        </svg>
                        {props.cover1} policy wording</a>
                      {/*&nbsp;&nbsp;Download Advantage policy book*/}
                    </div>)}
                  {(isActive(props.cover2)) && (
                    <>
                      {isActive(props.cover2) && isActive(props.cover1) ?
                        <div className="divider"></div> : <></>}
                      <div className="regularTextStyles"
                           style={{
                             paddingTop: "10px",
                             textDecoration: 'underline',
                             cursor: 'pointer',
                             color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                           }}>
                        <a
                          href={
                            props.inputValues.source === 'GASPY'
                              ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/gaspy_advantageplus.pdf"
                              : isVTNZPath
                                ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/VTNZ_advantageplus.pdf"
                                : isAAPath
                                  ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/AA_advantageplus.pdf"
                                  : "https://docs.autosure.co.nz/policy_books/autosure/mbi/advantage_plus.pdf"
                          }
                          target="_blank" rel="noopener noreferrer"
                          className="text-decoration-none"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px", // prevents &nbsp;&nbsp;
                            color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'
                          }}
                        >
                          <svg width="17" height="17" viewBox="0 0 18 20" fill="none"
                               xmlns="http://www.w3.org/2000/svg"
                               className="svg-break-on-mobile">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M0.350098 18.4004C0.350098 17.7376 0.887356 17.2004 1.5501 17.2004H15.9501C16.6128 17.2004 17.1501 17.7376 17.1501 18.4004C17.1501 19.0631 16.6128 19.6004 15.9501 19.6004H1.5501C0.887356 19.6004 0.350098 19.0631 0.350098 18.4004ZM4.30157 9.15186C4.7702 8.68323 5.53 8.68323 5.99862 9.15186L7.5501 10.7033L7.5501 1.60039C7.5501 0.93765 8.08735 0.400391 8.7501 0.400391C9.41284 0.400391 9.9501 0.937648 9.9501 1.60039L9.9501 10.7033L11.5016 9.15186C11.9702 8.68323 12.73 8.68323 13.1986 9.15186C13.6673 9.62049 13.6673 10.3803 13.1986 10.8489L9.59862 14.4489C9.37358 14.674 9.06836 14.8004 8.7501 14.8004C8.43184 14.8004 8.12661 14.674 7.90157 14.4489L4.30157 10.8489C3.83294 10.3803 3.83294 9.62049 4.30157 9.15186Z"
                                  fill={isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF'}/>
                          </svg>
                          {props.cover2} policy wording</a>
                        {/*&nbsp;&nbsp;Download Advantage Plus policy book*/}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
              </div>
        </div>
      </div>
      <div style={{
        display: 'flex', justifyContent: 'center', paddingTop: '30px'
      }}>
      </div>

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{width: "838.16px"}}>
          <div>
            <div>
              <div className="boldTextStyles">Important Information</div>
              <ul>
                <li className="regularTextStyles"><b>Pre-existing issues:</b> Not covered if they existed
                  before purchasing this insurance
                </li>
                <li className="regularTextStyles"><b>Your responsibilities:</b> Vehicle servicing and
                  maintenance
                </li>
                <li className="regularTextStyles"><b>Cancellations:</b> Cancel within 30 days for a full refund,
                  if you haven't claimed
                </li>
              </ul>
              <div className="regularTextStyles">Payment can be made by credit card or debit card to
                Autosure Insurance
                Limited. All amounts are in New Zealand dollars and include GST.
              </div>
              <br/>
              <div className="regularTextStyles">This is a summary only. See policy wordings for full terms, exclusions,
                conditions and
                benefits.
              </div>
              {props.inputValues.source === 'GASPY' && gaspyPromoEnabled && (
                <div className="mt-3 text-start">
                  <a href="https://autosure.co.nz/gaspy-free-fuel-promo-tcs" target="_blank" rel="noopener noreferrer">
                    <img
                      src={gaspyLearnMore}
                      alt="Free Fuel with Gaspy MBI - Limited Time Offer"
                      className="h-auto d-block"
                      style={{width: '450px'}}
                    />
                  </a>
                </div>
              )}
            </div>
          </div>
          <br/>
          <div>
            <div style={{paddingBottom: "10px"}}>
              <span className="boldTextStyles"> Have you selected your choice at the top of this page? </span>
            </div>
            <div>
              <ul className="regularTextStyles">
                <li style={{paddingBottom: "5px"}}>Yes - great simply click ‘Next’ to continue</li>
                {/*<li style={{paddingBottom:"5px"}}>If you want to think about it <br/> <span style={{ color: '#0073CF' ,  textDecoration: "underline", cursor: "pointer",}} onClick={() => saveAndEmailQuote()}> Save & email my quote </span></li>*/}
                <li style={{paddingBottom: "5px"}}>Or you can protect another car - <span style={{
                  color: isVTNZPath ? 'black' : isAAPath ? '#0d59bf' : '#1851a3', textDecoration: "underline",
                  cursor: "pointer",
                }}
                                                                                        onClick={handleNewQuoteClick}>
                  get another quote
                            </span>
                </li>
                {props.inputValues.source === 'TFAF' &&
                  <li style={{paddingBottom: "5px"}}>If you’d like to return to this quote later,
                    click ‘Get Quote’ in the email we sent you
                    until {new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString("en-GB", {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })}.</li>}
              </ul>
            </div>
          </div>
          {!isTurners && props.inputValues.saveQuoteButtonEnabled &&
            <p
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: "center",
                paddingTop: '10px'
              }}>
              <div style={{
                flex: 1, maxWidth: "200px",
              }}></div>
              <SaveEmailQuote showEmailPopup={showEmailPopup} setShowEmailPopup={setShowEmailPopup}
                              inputValues={props.inputValues}/>
              <button
                onClick={() => saveAndEmailQuote()}
                style={{
                  flex: 1,
                  color: 'white',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                  borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                  paddingLeft: 1,
                  paddingRight: 1,
                  paddingTop: 13,
                  paddingBottom: 13,
                  overflow: 'hidden',
                  border: '1px white solid',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'inline-flex',
                  width: "100%",
                  maxWidth: "200px",
                  background: props.inputValues.selectedTermAndCover ? '#AFAFb0' : '#AFAFb0',
                  cursor: props.inputValues.selectedTermAndCover ? 'pointer' : 'not-allowed',
                }}
                disabled={!props.inputValues.selectedTermAndCover}
              >
                Save & email quote
              </button>

            </p>
          }
          <p
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: "center",
              paddingTop: '10px'
            }}>


            <button
              className="float-end"
              onClick={() => props.prevStep()}
              style={{
                color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3',
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                background: 'white',
                border: isVTNZPath ? '1px #E87722 solid' : '1px #1851a3 solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                wordWrap: 'break-word',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                width: "100%",
                maxWidth: "200px"
              }}
            >
              Back
            </button>

            <button
              onClick={() => clickNext()}
              style={{
                color: 'white',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                overflow: 'hidden',
                border: isAAPath ? '1px #0d59bf solid' : isVTNZPath ? '1px #E87722 solid' : '1px #1851a3 solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                width: "100%",
                maxWidth: "200px",
                background: props.inputValues.selectedTermAndCover ? isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3' : (isVTNZPath ? '#f7e1d0' : '#B0C4DE'),
                cursor: props.inputValues.selectedTermAndCover ? 'pointer' : 'not-allowed',
              }}
              disabled={!props.inputValues.selectedTermAndCover}
            >
              Next
            </button>

          </p>
        </div>
      </div>
      <DeclarationPopupTFAF
        parentDeclarationPopupShow={declarationPopupShow}
        setParentDeclarationPopupShow={setDeclarationPopupShow}
        setParentShowDeclStatement={setShowDeclStatement}
        parentNextStep={props.nextStep}
        source={props.inputValues.source}
        digimbiEnabled={props.inputValues.digimbiEnabled}
      />

      {/* Mobile bottom fixed premium - duplicate for mobile view */}
      {(props.inputValues.selectedTermAndCover.coverName) && (
          <div className="scrollPremium-mobile-bottom" style={{
            background: isAAPath ? '#ffd400' : '#1851a3',
            color: isAAPath ? '#1851A3' : "white",
          }}>
            <div className="table-header" style={{
              padding: '5px 24px 0 24px',
              display: "flex",
              justifyContent: "space-between",
            }}>
              <div className="placeholderRegularTextStyles" style={{
                display: "flex",
                flexDirection: "column",
                fontWeight: '700'
              }}>
                <div className="subHeadingWhiteTextStyles regularSubHeadingStyles table-header">Your Premium
                </div>
              </div>
              <div
                className="subHeadingWhiteTextStyles regularSubHeadingStyles table-header">{getPremium1(props.inputValues.selectedTermAndCover.coverName, props.inputValues.selectedTermAndCover.term).formattedRetailAmount}</div>
            </div>
            <div
              className="placeholderTextStyles_12px table-header"
                style={{
                  padding: '0px 24px 10px 24px',
                }}
            >
              {props.inputValues.selectedTermAndCover.coverName} | {props.inputValues.selectedTermAndCover.term !== undefined && <>
              {props.inputValues.selectedTermAndCover.term / 12} {props.inputValues.selectedTermAndCover.term / 12 === 1 ? ' year term' : ' year term'} </>}
              | ${props.inputValues.excess} excess
            </div>
        </div>)}
    </Container>
  );
}
export default PolicyDetailsTFAF;
